import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerActivity } from './models';
import { invalidateVolunteerActivities } from './useVolunteerActivities';

export const useArchiveVolunteerActivityMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerActivity) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			activityId,
			impersonationContext,
		}: {
			activityId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerActivity>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/activities/${activityId}`,
				}),
				'DELETE'
			),
		onSuccess: data => {
			invalidateVolunteerActivities();
			onSuccess?.(data);
		},
		onError,
	});
};
